export const STORAGE_KEYS = {
  LOGGED_IN_USER: "LOGGED_IN_USER",
  ENTERPRISE_KPIS_DATA_SOURCE: "ENTERPRISE_KPIS_DATA_SOURCE",
};

export const saveToLocalStorage = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(error);
  }
};

export const getFromLocalStorage = key => {
  try {
    const item = localStorage.getItem(key);
    if (!item) return null;

    try {
      return JSON.parse(item);
    } catch {
      // Legacy encrypted entries cannot be parsed; clear stale session data.
      localStorage.removeItem(key);
      return null;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const removeFromLocalStorage = key => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error(error);
  }
};

export const removeAllLocalStorage = () => {
  try {
    localStorage.clear();
  } catch (error) {
    console.error(error);
  }
};

export const saveToSessionStorage = (key, value) => {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(error);
  }
};

export const getFromSessionStorage = key => {
  try {
    const item = sessionStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch (error) {
    console.error(error);
  }
};

export const removeFromSessionStorage = key => {
  try {
    sessionStorage.removeItem(key);
  } catch (error) {
    console.error(error);
  }
};

export const removeAllSessionStorage = () => {
  try {
    sessionStorage.clear();
  } catch (error) {
    console.error(error);
  }
};
